import banner1 from '../assets/images/background/banner-1.jpg'
import banner2 from '../assets/images/background/banner-2.jpg'
import About from './about'
import FormOne from './form1'
import AddressChangeForm from './formAdderssCha'
import RegulatorLossDamageForm from './formLossDamage'
import MobileNumberChangeForm from './formMobileNumCha'
import WhoWe from './whoWeAre'

function Home() {
    return (
        <>
            <section className="main-slider bg-black text-white">
                <div className="main-slider-wrap">
                    <div className="main-slider-item">
                        <div className="image">
                            <img src={banner1} alt="Slider" />
                        </div>
                    </div>
                </div>
            </section>
            <About />
            <FormOne />
            <MobileNumberChangeForm />
            <RegulatorLossDamageForm />
            <AddressChangeForm />
            <WhoWe />
        </>
    )
}

export default Home